import React, { useEffect } from "react";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import KindergartenComponent from "../../components/applicationComponents/kindergartenComponent/KindergartenComponent";

export default function KindergartenPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Kindergarten Details",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <KindergartenComponent disabled={false} />
    </>
  );
}
